import type { Theme } from './api';

/**
 * Ein Aufbau, je Projekt eingestellt (Konzept 3.11): Grundschema hell/dunkel, Markenfarbe,
 * Button-Farbe, Schrift. Alles landet als CSS-Variablen auf <html>; die Stylesheets kennen
 * nur die Variablen. Keine externen Schriften – der Raum lädt nichts von Dritten.
 */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  const scheme = theme.scheme === 'dark' ? 'dark' : 'light';
  root.dataset['scheme'] = scheme;

  const brand = isHexColor(theme.brand) ? theme.brand : scheme === 'dark' ? '#E0A14A' : '#1F4E5F';
  const action = isHexColor(theme.action) ? theme.action : brand;
  root.style.setProperty('--brand', brand);
  root.style.setProperty('--action', action);
  root.style.setProperty('--action-ink', readableOn(action));
  root.style.setProperty('--font', theme.font === 'serif' ? 'var(--font-serif)' : 'var(--font-sans)');
}

function isHexColor(value: unknown): value is string {
  return typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value);
}

/** Weiß oder Schwarz – je nachdem, was auf der Farbe lesbar bleibt. */
function readableOn(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  const lin = (c: number) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
  const luminance = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  return luminance > 0.4 ? '#111111' : '#ffffff';
}
